import { useEffect, useState } from 'react';
import AdminLayout from '../AdminLayout';
import { getInquiries } from '../../services/adminService';
import { getFAQsAdmin, getTestimonialsAdmin, getPasscodesAdmin } from '../../services/adminService';

export default function AdminDashboard() {
  const [inquiries, setInquiries] = useState([]);
  const [counts, setCounts] = useState({ faqs: 0, testimonials: 0, passcodes: 0 });
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    Promise.all([
      getInquiries(),
      getFAQsAdmin(),
      getTestimonialsAdmin(),
      getPasscodesAdmin(),
    ]).then(([inq, faqs, test, pass]) => {
      setInquiries(inq);
      setCounts({ faqs: faqs.length, testimonials: test.length, passcodes: pass.length });
      setLoading(false);
    });
  }, []);

  const unread = inquiries.filter(i => !i.read).length;
  const recent = inquiries.slice(0, 5);

  const fmt = (ts) => {
    if (!ts) return '—';
    const d = ts.toDate ? ts.toDate() : new Date(ts);
    return d.toLocaleDateString('en-IN', { day: 'numeric', month: 'short', year: 'numeric' });
  };

  return (
    <AdminLayout title="Dashboard">
      {loading ? <div className="admin-spinner">Loading…</div> : (
        <>
          <div className="admin-stats-grid">
            <div className="admin-stat-card">
              <div className="stat-value">{inquiries.length}</div>
              <div className="stat-label">Total Inquiries</div>
            </div>
            <div className="admin-stat-card" style={{ borderColor: unread > 0 ? '#e65100' : '#2e7d32' }}>
              <div className="stat-value" style={{ color: unread > 0 ? '#e65100' : '#2e7d32' }}>{unread}</div>
              <div className="stat-label">Unread Inquiries</div>
            </div>
            <div className="admin-stat-card">
              <div className="stat-value">{counts.testimonials}</div>
              <div className="stat-label">Testimonials</div>
            </div>
            <div className="admin-stat-card">
              <div className="stat-value">{counts.faqs}</div>
              <div className="stat-label">FAQs</div>
            </div>
            <div className="admin-stat-card">
              <div className="stat-value">{counts.passcodes}</div>
              <div className="stat-label">Active Passcodes</div>
            </div>
          </div>

          <div className="admin-section">
            <div className="admin-section-header">
              <h2>Recent Inquiries</h2>
            </div>
            <div className="admin-table-wrap">
              <table className="admin-table">
                <thead>
                  <tr><th>Name</th><th>Contact</th><th>Service</th><th>Source</th><th>Date</th><th>Status</th></tr>
                </thead>
                <tbody>
                  {recent.map(inq => (
                    <tr key={inq.id}>
                      <td>{inq.name}</td>
                      <td>{inq.contact}</td>
                      <td>{inq.service || inq.message || '—'}</td>
                      <td><span className={`badge badge-${inq.source}`}>{inq.source}</span></td>
                      <td>{fmt(inq.createdAt)}</td>
                      <td><span className={`badge badge-${inq.read ? 'read' : 'unread'}`}>{inq.read ? 'Read' : 'Unread'}</span></td>
                    </tr>
                  ))}
                  {recent.length === 0 && (
                    <tr><td colSpan={6} className="admin-empty">No inquiries yet</td></tr>
                  )}
                </tbody>
              </table>
            </div>
          </div>
        </>
      )}
    </AdminLayout>
  );
}
